import styled from 'styled-components';

import { ButtonDropdown, DropdownToggle } from 'reactstrap';

export const Container = styled.div`
  padding: 16px;
  //height: calc(100vh - 136px);
  overflow: auto;
  background-color: #fff;
  margin-bottom: 20px;
`;

export const Card = styled.div`
  background: #f6f6f6;
  border-radius: 10px;
  padding: 20px;
  overflow: none;
  margin-bottom: 20px;
`;

export const Header = styled.div`
  margin-bottom: 10px;

  h3 {
    font-family: Poppins;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
  }

  p {
    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #3d3d3d;
  }
`;

export const ConfigButton = styled(ButtonDropdown)`
  height: 50px;
  padding: 0px;
  padding-bottom: 4px;
  align-items: flex-end;
  align-self: flex-end;
  border: none;
  background-color: transparent;
  svg {
    color: #333;
    cursor: pointer;
  }
`;

export const ConfigDropdownToggle = styled(DropdownToggle)`
  display: flex;
  color: #0ccab4 !important;
  font-weight: bold;
  font-size: 12pt;
  text-decoration: underline !important;
  cursor: pointer;

  svg {
    color: #0ccab4;
  }
`;

export const MenuItem = styled.div`
  display: flex;
  flex-direction: row;
  padding: 6px;
`;
